import React, { Dispatch, SetStateAction, useEffect } from "react";
import classNames from "classnames";

import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import Modal, {
  ModalRow,
  ModalText,
  ModalTitle,
  OutsideClickModes,
} from "src/app/components/Modal/Modal";
import { isValidUrl } from "src/helpers/textHelper";
import { showErrorToast } from "src/utils/methods";

import "./AddLinksModal.scss";

interface AddLinksModalProps {
  onClose: () => void;
  onConfirmClick: (links: string[]) => void;
  value: string;
  setValue: Dispatch<SetStateAction<string>>;
}

export default function AddLinksModal({
  onClose,
  onConfirmClick,
  value,
  setValue,
}: AddLinksModalProps) {
  const isStringLongerThenOneLine = value.includes("\n");

  const handleConfirmClick = () => {
    const links = value.split("\n").filter((el) => el !== "");
    const areAllLinksValid = links.every(isValidUrl);
    if (areAllLinksValid) {
      onConfirmClick(links);
      onClose();
    } else {
      showErrorToast({
        id: "ws_invalid_urls",
        defaultMessage: "One or more links are invalid",
      });
    }
  };

  useEffect(() => {
    return () => {
      setValue("");
    };
  }, []);

  return (
    <Modal
      className="add-links-modal"
      closeButtonText={
        <IDHFormattedMessage id="ws_cancel" defaultMessage="Cancel" />
      }
      confirmButtonText={
        <IDHFormattedMessage id="ws_confirm" defaultMessage="Confirm" />
      }
      onClose={onClose}
      displayCancelButton
      onConfirmClick={handleConfirmClick}
      closeButtonVariant="white-with-black-border"
      confirmButtonDisabled={value.length === 0}
      outsideClick={OutsideClickModes.Warn}
    >
      <ModalText>
        <ModalTitle>
          <IDHFormattedMessage
            id="ws_paste_links"
            defaultMessage="Paste link(s)"
          />
        </ModalTitle>

        <IDHFormattedMessage
          id="ws_you_can_add_several_at_once"
          defaultMessage="You can add several at once, separating with spaces."
        />
      </ModalText>
      <ModalRow>
        <textarea
          className={classNames("add-links-modal__textarea", {
            "add-links-modal__textarea--not-empty": isStringLongerThenOneLine,
          })}
          value={value}
          onChange={(e) => setValue(e.target.value.replace(/[ ,]/g, "\n"))}
        />
      </ModalRow>
    </Modal>
  );
}
